module.exports = [
	'Facebook',
	'Twitter',
	'Website',
	'Friends / Family',
	'Magazine',
];


//////////////////
// WEBPACK FOOTER
// ../server/constants/heardAboutSources.js
// module id = 1193
// module chunks = 0